import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { customLocalStorage, getCurrentConnectionType, getCurrentScreenOrientation } from '@crehana/utils';
import { setCloudflareAccessQAHeaders } from "./utils";
export var VIDEO_ANALYTICS_ENDPOINT = '/api/v3/video-analytics/';
export var EVENTS_MISSING_ERROR_MESSAGE = 'You need to provide either a single event or a list of events';
export var VIDEO_ANALYTICS_SENTRY_ERROR_MESSAGE = 'CREH - VideoAnalytics Error';
var showLogs = function showLogs(_ref) {
  var status = _ref.status,
    events = _ref.events,
    payload = _ref.payload,
    message = _ref.message,
    retries = _ref.retries;
  if (customLocalStorage.getItem('video_analytics_logger_enabled')) {
    // This is considered a side effect so babel doesn't remove this constants
    var _console = console,
      group = _console.group,
      groupEnd = _console.groupEnd,
      info = _console.info;
    group('------ VideoAnalytics track ------');
    if (events) {
      info('events:', events);
    }
    if (payload) {
      info('payload:', payload);
    }
    info('status:', status);
    if (message) {
      info('message:', message);
    }
    if (retries) {
      info('retries:', retries);
    }
    groupEnd();
  }
};
var _sendTracks = function sendTracks(_ref2) {
  var payload = _ref2.payload,
    retries = _ref2.retries,
    jwtToken = _ref2.jwtToken,
    sendErrorToSentry = _ref2.sendErrorToSentry;
  return new Promise(function (resolve) {
    var eventNames = payload[0].events.map(function (ev) {
      return ev.name;
    });
    var envEndpoint = process.env.NODE_ENV === 'development' ? 'https://qa.creha.co' : 'https://www.crehana.com';
    var completeEndpoint = window.location.href.includes('file://') ? "".concat(envEndpoint).concat(VIDEO_ANALYTICS_ENDPOINT) : VIDEO_ANALYTICS_ENDPOINT;
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    if (window.location.href.includes('file://') && jwtToken) {
      headers.append('REQUEST_CURRENT_PLATFORM', 'desktop');
      headers.append('Authorization', "JWT ".concat(jwtToken));
    }
    setCloudflareAccessQAHeaders(headers);
    fetch(completeEndpoint, {
      method: 'POST',
      headers: headers,
      credentials: 'include',
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json();
    }).then(function (res) {
      var status = 'success' in res ? 'success' : 'error';
      var message = '';
      if (Array.isArray(res) && res.length) {
        var _res$;
        message = (_res$ = res[0]) === null || _res$ === void 0 ? void 0 : _res$.message;
      } else if ('message' in res) {
        message = res.message;
      }
      showLogs({
        status: status,
        events: eventNames,
        payload: payload,
        message: message,
        retries: retries
      });
      if (status === 'error') {
        if (!retries || retries < 3) {
          _sendTracks({
            payload: payload,
            retries: (retries || 0) + 1,
            jwtToken: jwtToken,
            sendErrorToSentry: sendErrorToSentry
          }).then(function (response) {
            return resolve(response);
          });
        } else if (sendErrorToSentry) {
          // If the request fails after every retry, send error to sentry
          sendErrorToSentry(VIDEO_ANALYTICS_SENTRY_ERROR_MESSAGE, {
            payload: JSON.stringify(payload),
            response: res
          });
        }
      }
      resolve({
        status: status,
        message: message
      });
    })["catch"](function (err) {
      var message = err;
      showLogs({
        status: 'error',
        events: eventNames,
        payload: payload,
        message: message,
        retries: retries
      });
      if (!retries || retries < 3) {
        _sendTracks({
          payload: payload,
          retries: (retries || 0) + 1,
          jwtToken: jwtToken,
          sendErrorToSentry: sendErrorToSentry
        }).then(function (response) {
          return resolve(response);
        });
      }
      resolve({
        status: 'error',
        message: message
      });
    });
  });
};
var createEvent = function createEvent(event, player) {
  return {
    name: event.name,
    date: new Date().toISOString(),
    position: event.position,
    player: _objectSpread(_objectSpread({}, player), {}, {
      network: getCurrentConnectionType()
    }),
    screen: {
      width: window.screen.width,
      height: window.screen.height,
      orientation: getCurrentScreenOrientation()
    },
    duration: event.duration || undefined
  };
};
var trackVideoAnalytics = function trackVideoAnalytics(_ref3) {
  var event = _ref3.event,
    events = _ref3.events,
    user = _ref3.user,
    video = _ref3.video,
    player = _ref3.player,
    jwtToken = _ref3.jwtToken,
    sendErrorToSentry = _ref3.sendErrorToSentry;
  return new Promise(function (resolve) {
    _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var eventList, payload;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            eventList = [];
            if (events !== null && events !== void 0 && events.length) {
              eventList = events.map(function (ev) {
                return createEvent(ev, player);
              });
            } else if (event) {
              eventList = [createEvent(event, player)];
            } else {
              showLogs({
                status: 'error',
                message: EVENTS_MISSING_ERROR_MESSAGE
              });
              resolve({
                status: 'error',
                message: EVENTS_MISSING_ERROR_MESSAGE
              });
            }
            payload = [_objectSpread(_objectSpread({
              events: eventList,
              api_version: 2
            }, user), video)];
            _context.next = 5;
            return _sendTracks({
              payload: payload,
              jwtToken: jwtToken,
              sendErrorToSentry: sendErrorToSentry
            }).then(function (response) {
              return resolve(response);
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  });
};
export default trackVideoAnalytics;